import React from 'react'
import { Form, Select } from 'antd'
import { useRef } from 'react'

export const DropdownGroupSelect = ({
  editable,
  name,
  message,
  initialValue,
  tagRender,
  className,
  width,
  options = [],
  placeholder,
  required = false,
  mode = null,
  size = 'small',
  ...others
}) => {
  if (!editable) return initialValue
  const { Option, OptGroup } = Select
  const wrapperRef = useRef(null)

  return (
    <div ref={wrapperRef}>
      <Form.Item name={name} rules={[{ required: required, message: { message } }]}>
        <Select
          getPopupContainer={(_) => wrapperRef?.current}
          className={className}
          size={size}
          placeholder={placeholder}
          mode={mode}
          tagRender={tagRender}
          style={{ width: width }}
          {...others}
        >
          {options.map((g, i) => {
            const formattedName = g.name.toString().toUpperCase()
            if (g.options.length === 0) return null
            return (
              <OptGroup key={g.name} label={formattedName}>
                {g.options.map((o, j) => {
                  const formattedValue = o.toString().toUpperCase()
                  return (
                    <Option value={formattedValue} key={i.toString() + j.toString()}>
                      {formattedValue}
                    </Option>
                  )
                })}
              </OptGroup>
            )
          })}
        </Select>
      </Form.Item>
    </div>
  )
}
